import React, { useEffect, useState } from "react";
import {
  Box,
  Drawer,
  List,
  ListItem,
  ListItemText,
  Typography,
  Card,
  CardContent,
  Button,
  IconButton,
  Grid,
  Modal,
  TextField,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { useForm } from "react-hook-form";
import {
  useAddShop,
  useCreateProject,
  useDeleteProject,
  useGetProjectList,
  useGetValidate,
  useModifyProject,
} from "../services/authService";
import { useLocation, useNavigate } from "react-router-dom";
import { useProject } from "./ProjectContext";
import Swal from "sweetalert2";

export default function Dashboard() {
  const [open, setOpen] = useState(false);
  const { mutate: createProject } = useCreateProject();
  const { mutate: addShop } = useAddShop();
  const { data: projectData } = useGetProjectList();
  const projectListData = projectData?.data || [];
  console.log("projectListData", projectListData);
  const { setSelectedProject } = useProject();

  const navigate = useNavigate();

  // logout handler
  const handleLogout = () => {
    sessionStorage.removeItem("authToken"); // 🔹 remove token
    navigate("/auth"); // 🔹 redirect to login/auth page
  };

  // Utility to parse hash params (like linkToken, shop)
  function useHashParams() {
    const { hash } = useLocation();
    return new URLSearchParams(hash.replace(/^#/, ""));
  }

  // Utility to parse query params (like token)
  function useQueryParams() {
    const { search } = useLocation();
    return new URLSearchParams(search);
  }

  const params = useQueryParams();
  // const token = params.get("token");
  const token = sessionStorage.getItem("shopifyToken");
  const hasToken = Boolean(token);

  const hashParams = useHashParams();
  const queryParams = useQueryParams();

  const linkToken = hashParams.get("linkToken");
  const shop = hashParams.get("shop");
  // const token = queryParams.get("token");

  const { data: userData } = useGetValidate(linkToken || token);
  const { mutate: deleteMutate } = useDeleteProject();
  const { mutate: modifyProject } = useModifyProject();
  console.log("userData", userData?.data?.shop);
  const shopName = userData?.data?.shop?.shop || "";

  const [mode, setMode] = useState("create"); // create | edit
  const [editingProject, setEditingProject] = useState(null);

  // react-hook-form
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
    reset();
  };

  const onSubmit = (data) => {
    if (mode === "create") {
      createProject(data);
    } else {
      modifyProject({
        id: editingProject.project_id,
        payload: data,
      });
    }
    handleClose();
  };

  // handle link with shop
  const handleLinkShop = (projectId) => {
    addShop({ linkToken: token, projectId });
  };

  return (
    <Box sx={{ display: "flex", height: "100vh" }}>
      {/* Main Content */}
      <Box sx={{ flexGrow: 1 }}>
        {projectListData.length > 0 &&
          !!token &&
          projectListData.every(
            (project) => !project?.shop || !project?.shop?.shop?.trim()
          ) && (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                backgroundColor: "#fff3cd",
                border: "1px solid #ffeeba",
                borderRadius: "8px",
                padding: "12px 20px",
                maxWidth: "900px",
                margin: "0 auto",
                boxShadow: "0px 2px 6px rgba(0,0,0,0.08)",
                marginBottom: "15px",
              }}
            >
              <Typography
                variant="body1"
                sx={{
                  fontWeight: 500,
                  fontSize: "16px",
                  color: "#856404",
                  textAlign: "center",
                }}
              >
                ⚠️{" "}
                {`To get started on a new project, add your shop to a project below`}
              </Typography>
            </Box>
          )}

        {/* {projectListData.length > 0 && !token && (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              backgroundColor: "#fff3cd",
              border: "1px solid #ffeeba",
              borderRadius: "8px",
              padding: "12px 20px",
              maxWidth: "900px",
              margin: "0 auto",
              boxShadow: "0px 2px 6px rgba(0,0,0,0.08)",
              marginBottom: "15px",
            }}
          >
            <Typography
              variant="body1"
              sx={{
                fontWeight: 500,
                fontSize: "16px",
                color: "#856404",
                textAlign: "center",
              }}
            >
              ⚠️{" "}
              {`To get started on a new project, install the Atttic3D app on your shopify store and add the shop to the project below`}
            </Typography>
          </Box>
        )} */}

        <Grid container spacing={3}>
          {/* Add Project Card */}
          <Grid item xs={12} sm={6} md={3}>
            <Card
              variant="outlined"
              sx={{
                height: 400,
                backgroundColor: "#0a3d62",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                cursor: "pointer",
                width: "300px",
                borderRadius: "10%",
              }}
              onClick={() => {
                setMode("create");
                setEditingProject(null);
                reset({ project_name: "", description: "" });
                setOpen(true);
              }}
            >
              <Box sx={{ textAlign: "center" }}>
                <AddIcon fontSize="large" style={{ color: "white" }} />
                <Typography variant="body1" color="white">
                  Add new project
                </Typography>
              </Box>
            </Card>
          </Grid>

          {/* Project Cards from API */}
          {projectListData.map((project) => (
            <Grid
              item
              xs={12}
              sm={6}
              md={3}
              key={project._id}
              style={{ height: 400, width: "300px" }}
            >
              <Card
                variant="outlined"
                style={{
                  height: "400px",
                  borderRadius: "10%",
                  position: "relative",
                }}
              >
                <IconButton
                  size="small"
                  sx={{ position: "absolute", top: 8, right: 40 }}
                  onClick={() => {
                    setMode("edit");
                    setEditingProject(project);
                    reset({
                      project_name: project.project_name,
                      description: project.description,
                    });
                    setOpen(true);
                  }}
                >
                  <EditIcon fontSize="small" />
                </IconButton>

                <IconButton
                  size="small"
                  sx={{ position: "absolute", top: 8, right: 8 }}
                  onClick={() => {
                    Swal.fire({
                      title: "Are you sure?",
                      text: "This project will be permanently deleted",
                      icon: "warning",
                      showCancelButton: true,
                      confirmButtonText: "Yes, delete it",
                    }).then((result) => {
                      if (result.isConfirmed) {
                        deleteMutate(project.project_id);
                      }
                    });
                  }}
                >
                  <DeleteIcon fontSize="small" />
                </IconButton>

                <CardContent>
                  <Typography variant="caption" color="textSecondary">
                    Created {new Date(project.created_at).toLocaleDateString()}
                  </Typography>
                  <Typography
                    variant="h6"
                    sx={{ fontWeight: "bold", mt: 1, mb: 1 }}
                  >
                    {project.project_name}
                  </Typography>
                  <Typography variant="body2" color="textSecondary">
                    {project.description}
                  </Typography>

                  <Typography variant="body2" color="textSecondary">
                    Install Date:{" "}
                    {project?.shop?.installDate
                      ? new Date(project.shop.installDate)
                          .toISOString()
                          .replace("T", " ")
                          .slice(0, 19)
                      : "Not installed yet"}
                  </Typography>

                  {project?.shop?.reinstalledAt && (
                    <Typography variant="body2" color="textSecondary">
                      Reinstalled Date:{" "}
                      {project?.shop?.reinstalledAt
                        ? new Date(project.shop.reinstalledAt)
                            .toISOString()
                            .replace("T", " ")
                            .slice(0, 19)
                        : "-"}
                    </Typography>
                  )}

                  {project?.shop?.uninstalledAt && (
                    <Typography variant="body2" color="textSecondary">
                      Uninstalled Date:{" "}
                      {new Date(project.shop.uninstalledAt)
                        .toISOString()
                        .replace("T", " ")
                        .slice(0, 19)}
                    </Typography>
                  )}

                  <Box sx={{ mt: 2 }}>
                    {project?.shop?.shop ? (
                      <Button
                        variant="contained"
                        sx={{
                          backgroundColor: "#201d1dff",
                          color: "#fff",
                          width: "100%",
                          mb: 1,
                          "&:hover": { backgroundColor: "#000000ff" },
                        }}
                        onClick={() => {
                          setSelectedProject(project);
                          navigate(
                            `/projects?shop=${project?.shop?.shop}&project_id=${
                              project.project_id
                            }&project_name=${encodeURIComponent(
                              project.project_name
                            )}`
                          );
                        }}
                      >
                        View Shop
                      </Button>
                    ) : (
                      <Button
                        variant="contained"
                        disabled={!hasToken}
                        sx={{
                          backgroundColor: "#FFD600",
                          color: "#000",
                          width: "100%",
                          mb: 1,
                          "&:hover": { backgroundColor: "#FFC400" },
                        }}
                        onClick={() => handleLinkShop(project.project_id)}
                      >
                        Add Shop
                      </Button>
                    )}
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>

      {/* Modal for Add Project */}
      <Modal open={open} onClose={handleClose}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            bgcolor: "background.paper",
            borderRadius: 2,
            boxShadow: 24,
            p: 4,
          }}
        >
          <Typography variant="h6" gutterBottom>
            {mode === "create" ? "Create New Project" : "Update Project"}
          </Typography>

          <form onSubmit={handleSubmit(onSubmit)}>
            <TextField
              label="Project Name"
              fullWidth
              margin="normal"
              {...register("project_name", {
                required: "Project name is required",
              })}
              error={!!errors.project_name}
              helperText={errors.project_name?.message}
            />
            <TextField
              label="Description"
              fullWidth
              margin="normal"
              multiline
              rows={3}
              {...register("description", {
                required: "Description is required",
              })}
              error={!!errors.description}
              helperText={errors.description?.message}
            />

            <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
              <Button onClick={handleClose} sx={{ mr: 2 }}>
                Cancel
              </Button>
              <Button
                type="submit"
                variant="contained"
                sx={{ bgcolor: "#FFD600", color: "#000" }}
              >
                {mode === "create" ? "Save" : "Update"}
              </Button>
            </Box>
          </form>
        </Box>
      </Modal>
    </Box>
  );
}
